/** The open asset's title and secondary line (data/assetName.ts) from the twin store; null while no asset is open. */
import { useMemo } from 'react';
import { assetName, type AssetName } from '../../data/assetName';
import { useTwin } from '../../store';

export function useAssetName(): AssetName | null {
  const asset = useTwin((s) => s.asset);
  const element = useTwin((s) => s.element);
  const assetId = useTwin((s) => s.assetId);
  return useMemo(() => {
    const id = assetId ?? element?.id;
    return id ? assetName(asset, element, id) : null;
  }, [asset, element, assetId]);
}
